import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PrintAttendance() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) return;
    const base = user.role === "school_admin" ? "/school/attendance/export" : "/teacher/attendance/export";
    api
      .get(base, {
        params: {
          from: params.get("from"),
          to: params.get("to"),
          class_id: params.get("class_id") || undefined,
          format: "json",
        },
      })
      .then((r) => {
        setData(r.data);
        setTimeout(() => window.print(), 500);
      })
      .catch((e) => setError(formatErr(e, "Could not load the report")));
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return <div className="p-10 text-center font-semibold text-red-500" data-testid="print-error">{error}</div>;
  }
  if (!data) {
    return <div className="p-10 text-center text-slate-400">Preparing report…</div>;
  }

  return (
    <div className="min-h-screen bg-white p-8 print:p-2" data-testid="print-attendance-report">
      <div className="flex items-end justify-between border-b-2 border-slate-800 pb-4 mb-6">
        <div>
          <h1 className="text-2xl font-extrabold">Attendance Report</h1>
          <p className="text-sm text-slate-500 mt-1">
            {data.school_name} · {data.class_label}
          </p>
        </div>
        <p className="text-sm font-semibold">
          {data.from} → {data.to}
        </p>
      </div>
      {data.rows.length === 0 ? (
        <p className="text-sm text-slate-400">No attendance records in this range.</p>
      ) : (
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr>
              {data.header.map((h) => (
                <th key={h} className="border border-slate-300 bg-slate-100 px-3 py-2 text-left text-xs uppercase tracking-wide">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r, i) => (
              <tr key={i}>
                {r.map((cell, j) => (
                  <td key={j} className="border border-slate-300 px-3 py-1.5">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p className="text-xs text-slate-400 mt-4">
        {data.total} records · Generated by EDUJAC
      </p>
    </div>
  );
}
